import React, { useState } from 'react';

import styled from 'styled-components';

import { updateCompany } from 'apis/UserAPI';
import Button from 'components/lib/Button';
import Dropdown from 'components/lib/Dropdown';

import { CompanyListItemType } from './types';
import DownCaretIcon from '../../../common/Icons/DownCaretIcon';
import { useRootContext } from '../../layout/RootContext';
import { useCompaniesContext } from '../CompaniesContext';
import CompaniesCreateEditModal from '../create/CompaniesCreateEditModal';
import { mapRequest } from '../create/utils';

type Props = {
  item: CompanyListItemType;
};

const Wrapper = styled.div`
  visibility: hidden;
`;

const CompaniesTableActions = ({ item }: Props) => {
  const { showMessage } = useRootContext();

  const { refetch, onEnterSupportMode } = useCompaniesContext();

  const [openEditModal, setOpenEditModal] = useState<boolean>(false);

  const getErrorMessage = (errorResponse: any) => {
    const candidate =
      errorResponse?.primary_user_id ??
      errorResponse?.p_c_email ??
      errorResponse?.non_field_errors ??
      errorResponse?.detail;

    if (Array.isArray(candidate) && candidate.length > 0) {
      return candidate[0];
    }

    if (typeof candidate === 'string') {
      return candidate;
    }

    return 'Failed to update company';
  };

  const onUpdate = async (company: CompanyListItemType) => {
    const payload = mapRequest(company);
    try {
      await updateCompany(item.id ?? -1, payload);
      showMessage('success', 'Company updated successfully');
      refetch();
    } catch (reason: any) {
      console.error(reason);

      const errorResponse = reason?.response?.data;
      showMessage('error', getErrorMessage(errorResponse));
      throw reason;
    }
  };

  return (
    <Wrapper className={'hover-visible'}>
      <CompaniesCreateEditModal
        open={openEditModal}
        editCompany={item}
        handleClose={() => setOpenEditModal(false)}
        onSubmit={onUpdate}
        title="Edit Company"
      />
      <Dropdown
        menu={{
          items: [
            {
              label: 'Edit',
              key: 'edit',
              onClick: () => setOpenEditModal(true),
            },
            {
              label: 'Enter Support Mode',
              key: 'enterSupportMode',
              onClick: () => onEnterSupportMode(item),
            },
          ],
        }}
      >
        <Button style={{ width: 100 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span>Actions</span>
            <DownCaretIcon />
          </div>
        </Button>
      </Dropdown>
    </Wrapper>
  );
};

export default CompaniesTableActions;
